export default __webpack_public_path__ + "static/media/phone-3d.aba788a3.png";